import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { StorageService } from '../../services/storage.service';
import { Constants } from '../../data/constants/constants.enum';
import { AuthenticationService } from '../../services/authentication.service';
import {TermsAndConditionsService} from '../../services/terms-and-conditions.service';
import {UserService} from '../../services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private oktaAuth: OktaAuthService,
        private router: Router,
        private storageService: StorageService,
        private authenticationService: AuthenticationService,
        private termsAndConditionsService: TermsAndConditionsService,
        private userService: UserService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const invalidMarketIds = ['/', '/login', '/login/terms'];
        if (invalidMarketIds.indexOf(state.url) < 0) {
            this.storageService.setItem(Constants.RETURN_URL_KEY, state.url, 'session');
        }
        return this.oktaAuth.isAuthenticated()
            .then(
                (authenticated) => {
                    if (authenticated) {
                        this.authenticationService.updateAuthenticationState(true);

                        // If user is does not have correct app authorization, kick them to the non-permission page
                        if (state.url !== '/unauthorized') {
                            return this.userService.getUser().then(user => {
                                if (user.hasAuthority(window['__tvbEnv'].appAuthorityName)) {
                                    if (state.url === '/login/terms') {
                                        return true;
                                    }
                                    // If user is authenticated and has authorization but terms are not accepted, redirect to terms page.
                                    return this.termsAndConditionsService.hasAcceptedTerms().then(accepted => {
                                        if (!accepted) {
                                            this.router.navigateByUrl('login/terms').catch(err => console.log(err));
                                        }
                                        return accepted;
                                    })
                                } else {
                                    this.router.navigateByUrl('unauthorized');
                                }
                            });
                        }
                    } else {
                        this.authenticationService.updateAuthenticationState(false);
                        this.router.navigate(['welcome']).catch(err => console.error(err));
                    }
                    return authenticated;
                }
            )
            .catch(
                (err) => {
                    console.error(err);
                    return false;
                }
            );
    }
}
